export const Hogar = {
  codProducto: 'HOGAR',
  //  prodCodigoCore: 'hogarCotizadorDTC',
  prodCodigoCore: 'hogarCotizadorDTC',
  prodCodigoCoreFlex: 'hogarCotizadorFlex',
  proTipoPlan: 'Abierto',

  urls: {
    datosPersonales: '/hogar1',
    coberturas: '/hogar2',
    opcionPago: '/hogar3',
    datosGenerales: '/hogar3',
    recuperar: '/recuperar-cotizacion-hogar',

    individualFlexible1: '/individual-flexible',
    individualFlexible2: '/individual-flexible-coberturas',

    emisionContratante: '/hogar-emision-contratante',
    emisionAsegurado: '/hogar-emision-asegurado',
    vigenciaPoliza: '/hogar-vigencia',
    pagoPoliza: '/hogar-pago-poliza',
    finCompra: '/hogar-fin-compra',
  },

  /********Produccion********/
  encriptar: {
    resumen: true,
    catalogo: true,
    actualizar: true,
    tarifar: true,
    recuperar: true,
    asegurado: true,
  },

  logueoRequerido: true,
  /********Produccion********/

  // logueoRequerido: false,
  /********Desarrollo********/
};
